import axios from 'axios';
import store from './store'
// import router from './router'

const req_url = store.state.req_url

export default async(type='get', url = '', data = {}, cb) => {
	let res
	let config = {
		 headers:{'content-Type': 'application/json; charset=UTF-8'}
	}
	if (type=='get') {
		await axios.get(req_url + url).then(response =>{ res = response})
			          .catch(error => {
									cb(error)
								})
	}else{
		await axios.post(req_url + url, JSON.stringify(data), config).then(response =>{
							res = response
					}).catch(error => {
						cb(error)
					})
	}
	// if (res.data.code == 1003 || res.data.code == 1001) {
	// 	store.commit('updateUser', '')
	// 	store.commit('updateUserKey', '')
	// 	store.commit('updateFilter', '')
	// 	store.commit('topicEntityCount', '')
	// 	store.commit('topicTagCount', '')
	// 	// localStorage.clear()
	// 	window.localStorage.removeItem('timestamp_left')
	// 	window.localStorage.removeItem('timestamp_right')
	// 	window.localStorage.removeItem('user')
	// 	window.localStorage.removeItem('user_key')
	// 	window.localStorage.removeItem('show_scientific')

	// 	router.replace({name: 'NewsList', query: { login_lose: true }})
	// 	return await res.data
	// }
	return await res.data
}
